<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
  }
}
</script>

<style lang="scss">
@import "plumber-sass/_plumber.scss";
@import "constants/_style.scss";

@font-face{font-family:'Atlas Grotesk Regular';font-style:normal;font-weight:400;font-display:swap;src:url(https://bellingcat.com/app/themes/bellingcat/assets/fonts/AtlasGrotesk-Regular-Web.woff2?v=3.11) format("woff2"),url(/app/themes/bellingcat/assets/fonts/AtlasGrotesk-Regular-Web.woff?v=3.11) format("woff"),url(/app/themes/bellingcat/assets/fonts/AtlasGrotesk-Regular-Web.eot?v=3.11) format("eot")}
@font-face{font-family:'Atlas Grotesk Medium';font-style:normal;font-weight:400;font-display:swap;src:url(https://bellingcat.com/app/themes/bellingcat/assets/fonts/AtlasGrotesk-Medium-Web.woff2?v=3.11) format("woff2"),url(/app/themes/bellingcat/assets/fonts/AtlasGrotesk-Medium-Web.woff?v=3.11) format("woff")}
@font-face{font-family:'Atlas Grotesk Italic';font-style:normal;font-weight:400;font-display:swap;src:url(https://bellingcat.com/app/themes/bellingcat/assets/fonts/AtlasGrotesk-RegularItalic-Web.woff2?v=3.11) format("woff2"),url(/app/themes/bellingcat/assets/fonts/AtlasGrotesk-RegularItalic-Web.woff?v=3.11) format("woff")}
@font-face{font-family:'Atlas Grotesk Bold';font-style:normal;font-weight:400;font-display:swap;src:url(https://bellingcat.com/app/themes/bellingcat/assets/fonts/AtlasGrotesk-Bold-Web.woff2) format("woff2"),url(/app/themes/bellingcat/assets/fonts/AtlasGrotesk-Bold-Web.woff) format("woff")}
@font-face{font-family:'AtlasTypewriter Regular';font-style:normal;font-weight:400;font-display:swap;src:url(https://bellingcat.com/app/themes/bellingcat/assets/fonts/AtlasTypewriter-Regular-Web.woff2) format("woff2"),url(/app/themes/bellingcat/assets/fonts/AtlasTypewriter-Regular-Web.woff) format("woff")}

* {
  box-sizing: border-box;
}

.flex {
  display: flex;
}

body,
html {
  margin: 0;
  padding: 0;
  font-family: "Atlas Grotesk Regular",sans-serif;
  // font-family: jaf-lapture, sans-serif;
  width: 100vw;
  overflow: hidden;
}

body {
  background-color: transparent;
  // background-image: linear-gradient(
  //     0deg,
  //     rgba(0, 0, 0, 0.3) 0%,
  //     rgba(0, 0, 0, 0.3) 1%,
  //     transparent 2%,
  //     transparent 49%,
  //     rgba(0, 0, 0, 0.3) 50%,
  //     rgba(0, 0, 0, 0.3) 51%,
  //     transparent 52%
  //   ),
  //   linear-gradient(
  //     90deg,
  //     rgba(0, 0, 0, 0.3) 0%,
  //     rgba(0, 0, 0, 0.3) 1%,
  //     transparent 2%,
  //     transparent 49%,
  //     rgba(0, 0, 0, 0.3) 50%,
  //     rgba(0, 0, 0, 0.3) 51%,
  //     transparent 52%
  //   );
  height: 100%;
  background-size: 32px 32px;
  overflow-x: none;
  font-variant-numeric: oldstyle-nums;
}

#app {
  
}

.w1 {
  width: calc(#{$grid} * #{$block-width} * 1 + #{$grid} * #{$gutter-width} * 0);
}

.w1p {
  width: calc(
    #{$grid} * #{$block-width} * 1.5 + #{$grid} * #{$gutter-width} * 0
  );
}

.w2 {
  width: calc(#{$grid} * #{$block-width} * 2 + #{$grid} * #{$gutter-width} * 1);
}

.h1 {
  height: calc(
    #{$grid} * #{$block-width} * 1 + #{$grid} * #{$gutter-width} * 0
  ) !important;
}

.h2 {
  height: calc(
    #{$grid} * #{$block-width} * 2 + #{$grid} * #{$gutter-width} * 1
  ) !important;
}

.h3 {
  height: calc(
    #{$grid} * #{$block-width} * 3 + #{$grid} * #{$gutter-width} * 2
  ) !important;
}

.h4 {
  height: calc(
    #{$grid} * #{$block-width} * 4 + #{$grid} * #{$gutter-width} * 3
  ) !important;
}

.w2p {
  width: calc(
    #{$grid} * #{$block-width} * 2.5 + #{$grid} * #{$gutter-width} * 1
  );
}

.w3 {
  width: calc(#{$grid} * #{$block-width} * 3 + #{$grid} * #{$gutter-width} * 2);
}

.w3p {
  width: calc(
    #{$grid} * #{$block-width} * 3.5 + #{$grid} * #{$gutter-width} * 2
  );
}

.w4 {
  width: calc(#{$grid} * #{$block-width} * 4 + #{$grid} * #{$gutter-width} * 3);
}

.w5 {
  width: calc(#{$grid} * #{$block-width} * 5 + #{$grid} * #{$gutter-width} * 4);
}

.w4p {
  width: calc(
    #{$grid} * #{$block-width} * 4.5 + #{$grid} * #{$gutter-width} * 3
  );
}

.l1 {
  margin-left: calc(
    #{$grid} * #{$block-width} * 1 + #{$grid} * #{$gutter-width} * 1
  );
}

.l2 {
  margin-left: calc(
    #{$grid} * #{$block-width} * 2 + #{$grid} * #{$gutter-width} * 2
  );
}

.l3 {
  margin-left: calc(
    #{$grid} * #{$block-width} * 3 + #{$grid} * #{$gutter-width} * 3
  );
}

.l4 {
  margin-left: calc(
    #{$grid} * #{$block-width} * 4 + #{$grid} * #{$gutter-width} * 4
  );
}

.m1 {
  margin-left: calc( #{$grid} * #{$gutter-width});
}

.w2 .float {
  @include plumber(
    $grid-height: $grid,
    $baseline: 0.25,
    $font-size: 0.75,
    $line-height: 1,
    $leading-top: 0,
    $leading-bottom: 1
  );

  font-family: jaf-lapture-caption, sans-serif;
  position: absolute;
  width: calc(#{$grid} * #{$block-width} * 2 + #{$grid} * #{$gutter-width} * 1);
  top: calc(#{$grid} * #{$gutter-width} * 3.5);
  left: calc(#{$grid} * #{$block-width} * 2 + #{$grid} * #{$gutter-width} * 2);
}

// .float.left {
//   font-family: jaf-lapture-caption, sans-serif;
//   position: absolute;
//   width: calc(#{$grid} * #{$block-width} * 1 + #{$grid} * #{$gutter-width} * 0);
//   top: calc(#{$grid} * #{$gutter-width} * 3);
//   left: calc(
//     -1 * #{$grid} * #{$block-width} * 1 - #{$grid} * #{$gutter-width} * 1
//   );
// }

.share {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.align-bottom {
    align-items: flex-end;
  }
}

.p {
  @include plumber(
    $grid-height: $grid,
    $baseline: 0.25,
    $font-size: 1,
    $line-height: 2,
    $leading-top: 0,
    $leading-bottom: 1
  );

  margin-top: 0px !important;

  &-no-leading {
    @include plumber(
      $grid-height: $grid,
      $baseline: 0.25,
      $font-size: 1,
      $line-height: 1,
      $leading-top: 0,
      $leading-bottom: 1
    );
  }

  text-align: justify;
  margin-top: 16px;
  margin-bottom: 16px;
  position: relative;
  hyphens: auto;
}

.caption {
  @include plumber(
    $grid-height: $grid,
    $baseline: 0.25,
    $font-size: 0.75,
    $line-height: 1,
    $leading-top: 0,
    $leading-bottom: 1
  );

  font-family: jaf-lapture-caption, sans-serif;
}

img {
  width: 100%;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

// @media (max-width: 928px) {
//   .w1,
//   .w2,
//   .w2p,
//   .w3,
//   .w4,
//   .l1,
//   .l2,
//   .l3,
//   .float {
//     margin-left: 0px !important;
//     width: 100% !important;
//     position: relative !important;
//     left: 0px !important;
//     top: 0px !important;
//   }

//   img {
//     width: calc(100vw - 2 * #{$gutter-width} * #{$grid});
//   }

//   #app {
//     width: calc(100% - 2 * #{$gutter-width} * #{$grid});
//   }

//   .share {
//     flex-direction: column;
//   }
// }

a,
a:visited {
  color: black;
}
</style>
